var _circle, _circle2, _g, _circle3, _circle4, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVSxp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#1F2028"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 64,
    height: 64,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31.5,
    fill: "#1F2028",
    stroke: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M32 72.212.96 8.983l8.08-3.966L32 51.788 54.96 5.017l8.08 3.966L32 72.212Z",
    clipRule: "evenodd",
    opacity: 0.8
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 28,
    fill: "url(#b)",
    opacity: 0.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24,
    fill: "#1F2028"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M31.513 17.055a5.707 5.707 0 0 0-3.416 1.657c-.684.67-1.333 1.357-2.027 2.034-.347.352-.698.695-1.05 1.042-.35.348-.738.717-1.102 1.082-.365.365-.668.685-1.005 1.024a439.6 439.6 0 0 0-1.582 1.568c-.405.413-.8.84-1.2 1.253-.236.246-.49.474-.712.734a6.142 6.142 0 0 0-1.414 4.175c.019.82.237 1.625.636 2.345.227.436.49.852.787 1.244.195.273.338.268.595.058.05-.04.096-.085.138-.132.254-.264.503-.528.761-.791.365-.379.739-.756 1.103-1.139.365-.382.76-.804 1.143-1.199.182-.194.377-.372.56-.563.392-.409.774-.83 1.165-1.234s.787-.783 1.17-1.178a295.16 295.16 0 0 1 2.481-2.531c.52-.532 1.028-1.077 1.543-1.609.32-.325.65-.637.97-.958.444-.44.858-.879 1.294-1.318.436-.439.76-.734 1.134-1.112a475.66 475.66 0 0 0 2.502-2.516c.053-.053.104-.108.15-.167.205-.255.222-.312-.03-.492a7.978 7.978 0 0 0-1.237-.791A5.866 5.866 0 0 0 32.41 17h-.042c-.284 0-.568.018-.85.053l-.005-.005.001.007Zm7.36 5.41h-.054a2.535 2.535 0 0 0-1.916.879c-.042.046-.087.09-.134.131l-1.36 1.319-1.392 1.38c-.387.382-.774.756-1.156 1.138-.382.383-.792.809-1.205 1.209-.414.4-.854.819-1.281 1.23l-1.517 1.511-2.819 2.787-3.731 3.7c-.24.233-.244.264 0 .514.596.595 1.2 1.186 1.778 1.787.358.374.83.622 1.344.707.485.096.986.08 1.463-.049.357-.087.687-.26.96-.505l1.477-1.41c.346-.328.698-.654 1.04-.988.685-.67 1.36-1.345 2.046-2.01.556-.54 1.125-1.077 1.69-1.617l2.314-2.23c.72-.699 1.445-1.402 2.175-2.1a.475.475 0 0 1 .448-.206.479.479 0 0 1 .391.298 3.188 3.188 0 0 1 .551 2.149 3.015 3.015 0 0 1-.777 1.758c-.534.567-1.103 1.103-1.657 1.648-.396.386-.8.764-1.197 1.155-.511.501-1.014 1.011-1.525 1.512-.076.084-.147.172-.226.25l-.503.515c-.377.372-.76.734-1.13 1.107-.37.373-.795.81-1.19 1.216-.036.04-.076.066-.111.1-.445.41-.854.82-1.277 1.231-.2.194-.39.391-.587.585-.337.339-.685.67-1.01 1.015-.199.207-.199.334.037.497.387.294.8.553 1.232.777a6.275 6.275 0 0 0 3.437.483 5.65 5.65 0 0 0 3.113-1.402c.658-.57 1.245-1.212 1.859-1.827.444-.44.89-.91 1.365-1.363l1.285-1.279c.392-.39.778-.782 1.175-1.169.396-.386.889-.847 1.333-1.283.444-.436.89-.878 1.334-1.344.355-.357.682-.739.98-1.143a6.184 6.184 0 0 0 1.01-2.764c.06-.49.06-.986 0-1.477a6.132 6.132 0 0 0-.939-2.448 7.156 7.156 0 0 0-1.244-1.414 234.636 234.636 0 0 1-3.665-3.66 2.8 2.8 0 0 0-.942-.679 2.832 2.832 0 0 0-1.14-.24h-.017l-.134.018h-.001Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 59.284,
    x2: -9.421,
    y1: 48.315,
    y2: 6.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CFFA2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVSxp);
export default __webpack_public_path__ + "static/media/vSxp.8b60604b9525b5fc796202f8ccc8b315.svg";
export { ForwardRef as ReactComponent };